var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16Time(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "t27mt3v66a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#t27mt3v66a)",
    transform: "translate(-656 -267)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6c0 3.314-2.686 6-6 6S0 9.314 0 6s2.686-6 6-6 6 2.686 6 6z",
    transform: "translate(656 267) translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2.4L6 6 8.4 7.6",
    transform: "translate(656 267) translate(2 2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16Time);
export default __webpack_public_path__ + "static/media/ico16Time.8cd25b77.svg";
export { ForwardRef as ReactComponent };